// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__ITDCw","actions":"GroupTable_actions__1BO61","deleteModalFooter":"GroupTable_deleteModalFooter__120AV"};